import React from 'react'

function SearchMainPage() {
  return (
    <div style={{height:"75%"}} className='d-flex align-items-center justify-content-center'>
        <div className='d-flex flex-column align-items-center justify-content-center'>
            <img src='/img/searchImage.svg' alt="search"/>
            <div style={{fontSize:"16px"}}>What are you looking for?</div>
        </div>
    </div>
  )
}

export default SearchMainPage